export default __webpack_public_path__ + "static/media/delete.f08856f6.svg";